import { render, staticRenderFns } from "./QcqPage.vue?vue&type=template&id=906eebbc&scoped=true&lang=pug&"
import script from "./QcqPage.vue?vue&type=script&lang=js&"
export * from "./QcqPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906eebbc",
  null
  
)

export default component.exports